var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomPage',{attrs:{"title":"消息"}},[_c('div',{staticClass:"content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"detail",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }